import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import React from 'react';

import {
  useGetGroupDetailDispatch,
  useGetGroupDetailTableList,
} from './table-columns';

interface Props {
  parentIndex: number;
  guestIndex: number;
  isGroupedPrice?: boolean;
}

export default function ActivityGuestDetailTable(props: Props) {
  const { guestIndex, parentIndex, isGroupedPrice } = props;
  const { editable } = useFormState();

  const columns = useGetGroupDetailTableList(isGroupedPrice);

  const { dispatch, details, name } = useGetGroupDetailDispatch(
    parentIndex,
    guestIndex,
  );

  const { fields } = details;

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={fields}
        dispatch={dispatch}
        disabled={!editable}
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
}
